import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCloseRounded = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="m13.88 12 5.73-5.72a1.34 1.34 0 0 0-1.9-1.89L12 10.12 6.29 4.4a1.34 1.34 0 0 0-1.9 1.9l5.73 5.7-5.73 5.72a1.33 1.33 0 0 0 .44 2.19 1.33 1.33 0 0 0 1.46-.3L12 13.88l5.71 5.72a1.33 1.33 0 0 0 2.29-.94 1.33 1.33 0 0 0-.4-.95L13.89 12Z" />
  </svg>
);
export default SvgCloseRounded;
